import React from 'react';
import { Analytics } from "@vercel/analytics/react"
import { BrowserRouter as Router, Route, Routes, useLocation } from 'react-router-dom';
import { useEffect } from 'react';
import { pageview } from './utils/analytics';
import Home from './pages/Home';
import GuideAnalyseCV from './pages/GuideAnalyseCV';
import GuideOptimiserCVATS from './pages/GuideOptimiserCVATS';
import GuideRedigerCV from './pages/GuideRedigerCV';
import GuideReconversionCV from './pages/GuideReconversionCV';
import GuideLettreMotivation from './pages/GuideLettreMotivation';
import GuideEtudiantCV from './pages/GuideEtudiantCV';
import GuideScoreCV from './pages/GuideScoreCV';
import GuideFormatCV from './pages/GuideFormatCV';
import GuideErreursCV from './pages/GuideErreursCV';
import GuidePhotoCV from './pages/GuidePhotoCV';
import GuideLongueurCV from './pages/GuideLongueurCV';
import GuideMotsClesCV from './pages/GuideMotsClesCV';
import GuideCVTech from './pages/GuideCVTech';
import GuidesIndex from './pages/GuidesIndex';
import GuideDynamic from './pages/GuideDynamic';
import Pricing from './pages/Pricing';
import About from './pages/About';
import Demo from './pages/Demo';
import Methode from './pages/Methode';
import Barometre from './pages/Barometre';
import Comparatifs from './pages/Comparatifs';
import Vs from './pages/Vs';
import MentionsLegales from './pages/MentionsLegales';
import OkRdv from './pages/OkRdv';
import CvUploader from './components/CvUploader';
import CvGenerator from './components/CvGenerator/CvGenerator';
import CvGeneratorSimplified from './components/CvGenerator/CvGeneratorSimplified';
import AnalysisHistory from './components/AnalysisHistory';
import AnalysisStats from './components/AnalysisStats';
import UserDashboard from './components/UserDashboard';
import Register from './pages/Register';
import Login from './pages/Login';
import Profile from './pages/Profile';
import Subscription from './pages/Subscription';
import Referral from './pages/Referral';
import SubscriptionInfo from './pages/SubscriptionInfo';
import PremiumSuccess from './pages/PremiumSuccess';
import MyPremiumServices from './pages/MyPremiumServices';
import Success from './pages/Success';
import Cancel from './pages/Cancel';
import Header from './components/Header';
import Footer from './components/Footer';
import ToastProvider from './components/ToastProvider';
import AdminDashboard from './pages/AdminDashboard';
import PrivateRoute from './components/PrivateRoute'; 
import PasswordResetRequest from './components/Password/PasswordResetRequesxt';
import PasswordReset from './components/Password/PasswordReset';
import LinkedInCallback from './components/LinkedInCallback';
import AuthChecker from './components/AuthChecker';
import SessionExpiredModal from './components/SessionExpiredModal';
import { useSelector, useDispatch } from 'react-redux';
import { hideSessionExpiredModal } from './slices/authSlice';
// Routes de debug retirées pour la production
// add comment for test - force redeploy

function RouteChangeTracker() {
    const location = useLocation();
    useEffect(() => {
        pageview(location.pathname + location.search);
    }, [location]);
    return null;
}

function AppContent() {
    const dispatch = useDispatch();
    const { showSessionExpiredModal } = useSelector(state => state.auth);

    return (
        <div className="App overflow-x-hidden min-h-screen bg-slate-200">
            <Analytics />
            <AuthChecker />
            <Header />
            <RouteChangeTracker />
            <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/demo" element={<Demo />} />
                <Route path="/pricing" element={<Pricing />} />
                <Route path="/methode" element={<Methode />} />
                <Route path="/barometre" element={<Barometre />} />
                <Route path="/comparatifs" element={<Comparatifs />} />
                <Route path="/vs/:slug" element={<Vs />} />
                <Route path="/about" element={<About />} />
                <Route path="/mentions-legales" element={<MentionsLegales />} />
                <Route path="/okrdv" element={<OkRdv />} />
                <Route path="/guides" element={<GuidesIndex />} />
                <Route path="/guide/analyse-cv-ia" element={<GuideAnalyseCV />} />
                <Route path="/guide/optimiser-cv-ats" element={<GuideOptimiserCVATS />} />
                <Route path="/guide/rediger-cv-percutant" element={<GuideRedigerCV />} />
                <Route path="/guide/cv-reconversion-professionnelle" element={<GuideReconversionCV />} />
                <Route path="/guide/lettre-motivation" element={<GuideLettreMotivation />} />
                <Route path="/guide/cv-etudiant" element={<GuideEtudiantCV />} />
                <Route path="/guide/score-cv" element={<GuideScoreCV />} />
                <Route path="/guide/format-cv" element={<GuideFormatCV />} />
                <Route path="/guide/erreurs-cv" element={<GuideErreursCV />} />
                <Route path="/guide/photo-cv" element={<GuidePhotoCV />} />
                <Route path="/guide/longueur-cv" element={<GuideLongueurCV />} />
                <Route path="/guide/mots-cles-cv" element={<GuideMotsClesCV />} />
                <Route path="/guide/cv-tech" element={<GuideCVTech />} />
                {/* Route dynamique — doit être APRÈS toutes les routes statiques */}
                <Route path="/guide/:slug" element={<GuideDynamic />} />
                <Route path="/upload" element={<PrivateRoute element={<CvUploader />} />} />
                <Route path="/generator" element={<PrivateRoute element={<CvGenerator />} />} />
                <Route path="/generator-simple" element={<PrivateRoute element={<CvGeneratorSimplified />} />} />
                <Route path="/history" element={<PrivateRoute element={<AnalysisHistory />} />} />
                <Route path="/stats" element={<PrivateRoute element={<AnalysisStats />} />} />
                <Route path="/dashboard" element={<PrivateRoute element={<UserDashboard />} />} />
                <Route path="/profile" element={<PrivateRoute element={<Profile />} />} />
                <Route path="/register" element={<Register />} />
                <Route path="/login" element={<Login />} />
                <Route path="/subscription" element={<PrivateRoute element={<Subscription />} />} />
                <Route path="/subscriptionInfo" element={<PrivateRoute element={<SubscriptionInfo />} />} />
                <Route path="/referral" element={<PrivateRoute element={<Referral />} />} />
                <Route path="/premium/success" element={<PrivateRoute element={<PremiumSuccess />} />} />
                <Route path="/premium/my-services" element={<PrivateRoute element={<MyPremiumServices />} />} />
                <Route path="/success" element={<Success />} />
                <Route path="/cancel" element={<Cancel />} />
                <Route path="/admin/*" element={<PrivateRoute element={<AdminDashboard />} />} />
                <Route path="/reset-password-request" element={<PasswordResetRequest />} />
                <Route path="/reset-password/:token" element={<PasswordReset />} />
                <Route path="/r/:token" element={<PasswordReset />} />
                <Route path="/linkedin-callback" element={<LinkedInCallback />} />
                {false && (
                    <>
                        {/* Debug routes (désactivées en prod) */}
                        {/* <Route path="/export-test" element={<PrivateRoute element={<ExportTest />} />} /> */}
                        {/* <Route path="/debug-export" element={<PrivateRoute element={<DebugExport />} />} /> */}
                        {/* <Route path="/pdf-test" element={<PrivateRoute element={<PdfExportTest />} />} /> */}
                    </>
                )}
            </Routes>
            <Footer/>
            
            {/* Modal de session expirée */}
            <SessionExpiredModal 
                isVisible={showSessionExpiredModal}
                onClose={() => dispatch(hideSessionExpiredModal())}
            />
        </div>
    );
}

function App() {
    return (
        <Router>
            <ToastProvider>
                <AppContent />
            </ToastProvider>
        </Router>
    );
}

export default App;
